<template>
  <div class="pt-md-0 pt-4">
    <img :src="imgUrl" alt="" class="img-fluid main-banner">
    <div class="container containerMhide">
      <div class="card content-card">
        <div class="row" style="margin:0;">
          <div class="col-md-3 col-12 side-bar">
              <!-- <slot>Set Menu</slot> -->
              <menu-list v-on:subMenuToParent="childByValue"></menu-list>   
          </div>
          <div class="col-md-9 col-12 content">
              <!-- <slot>default side bar content</slot> -->
              <router-view name="mainpage" v-show="isShow()"></router-view>
              <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .main-banner{
    width:100%;
    height:200px;
    object-fit:cover;
  }
  @media(max-width: 480px) {
    .main-banner{
      display: none;
    }
    .containerMhide{
      padding-left: 0;
      padding-right: 0;
      padding-top: 1em;
    }
    .containerMhide .content-card{
      border: none;
      box-shadow: 0 0 0 rgba(0, 0, 0, 0);
    }
  }
</style>

<script>
import MenuList from './MenuList'

var aaa = `<div>
        <img :src="imgUrl" class="img-fluid" alt="" />
          </div>`

export default {
  name: 'my-side-bar-content',
  components: {
    MenuList,
    aaaList: {
      props: ['imgUrl'],
      template: aaa
    }
  },
  data () {    
    return {
      imgUrl : '',      
      // imgUrl2 : { url : require(`@/assets/images/banner-about-04.jpg`)}
      // imgUrl: 'https://images.unsplash.com/photo-1522204538344-922f76ecc041?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=50e38600a12d623a878983fc5524423f&auto=format&fit=crop&w=1351&q=80'
    }
  },
  methods:{
    // 更換圖檔
    selectImg(obj , path){    
        
      if(obj.children !== undefined) {
        if(obj.props !== undefined){
          this.imgUrl = require('@/assets/images/'+ obj.props +'.jpg')
        }
        else{
          obj.children.filter(o=>path.indexOf(o.path) > -1).forEach(o => {
          this.selectImg(o , path)})
        }        
      }
      else{        
        this.imgUrl = require('@/assets/images/'+ obj.props +'.jpg')        
      }
    },
    // 接收子層回傳參數用
    childByValue:function(childValue){      
      this.$router.options.routes.filter(o=>childValue.indexOf(o.path) > -1).forEach(o => {
        if(o.path !== '/'){
          this.selectImg(o , childValue)
        }
      })
    },
    isShow:function(){      
      var setting = require('../router/routerSetting')
      return setting.parentIsShow(window.location.pathname , this.$router.options.routes, ['1','headerlink']);
    }
  },
  created() {    
    var imgUrl = ''
    this.$router.options.routes.filter(o=>this.$route.path.indexOf(o.path) > -1).forEach(o => {
      if(o.path !== '/' && o.path !=='/En'){        
        this.selectImg(o , this.$route.path)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppSideBarContent.vue